import {
  PieChartOutlined,
  DesktopOutlined,
  UserOutlined,
} from "@ant-design/icons";
import { AUTHORITIES } from "./config/constants";

interface SideBarItemChild {
  name: string;
  route: string;
}

interface SideBarItem {
  name: string;
  icon: any;
  route?: string;
  childrens?: SideBarItemChild[];
  capabilities?: string[];
}

export const routes = {
  HOME: "/",
  PROJECT: "/project",
  LOGIN: "/login",
  CONTACT: "/contact",
  SYMPTOMS: "/symptoms",
  DASHBOARD: "/dashboard",
  CASE_MANAGEMENT: "/case-management",
  CASE_DETAILS: "/case-details/:id",
  CASE_REPORT: "/case-report",
  USER_REPORT: "/user-report",
  CREATE_USER: "/create-user",
  PROFILE: "/profile",
  REGISTER: "/register",
  AMILOIDOSI_CARDIACA: "malattie/amiloidosi-cardiaca",
  MALATTIA_DI_FABRY: "malattie/malattia-di-fabry",
  CARDIOMIOPATIA_IPERTROFICA_OSTRUTTIVA:
    "malattie/cardiomiopatia-ipertrofica-ostruttiva",
  IPERCOLESTEROLEMIA_FAMILIARE: "malattie/ipercolesterolemia-familiare",
  PATIENT_CONTACT: "/patient",
  PRIVACY_POLICY: "/privacy-policy",
  COOKIE_POLICY: "/cookie-policy",
  TERMS_AND_CONDITIONS: "/terms-and-conditions",
};

export const sidebar: SideBarItem[] = [
  {
    name: "Dashboard",
    icon: PieChartOutlined,
    route: routes.DASHBOARD,
    capabilities: [
      AUTHORITIES.ASL_DOCTOR,
      AUTHORITIES.SPECIALIST,
      AUTHORITIES.MANAGER,
    ],
  },
  {
    name: "Casi",
    icon: DesktopOutlined,
    route: routes.CASE_REPORT,
    capabilities: [AUTHORITIES.ASL_DOCTOR, AUTHORITIES.SPECIALIST],
  },
  {
    name: "Utenti",
    icon: UserOutlined,
    route: routes.USER_REPORT,
    capabilities: [AUTHORITIES.MANAGER],
  },
];
